"use client";
import React from "react";
import Link from "next/link";
import FacebookIcon from "../icons/facebook";
import ArrowIcon from "../icons/arrow45";
import InstagramIcon from "../icons/instagram";
import UpArrowIcon from "../icons/upArrowIcon";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const Footer: React.FC = () => {
  return (
    <div className="relative z-20 mt-12">
      <div className="absolute -top-1.5 left-1/2 transform -translate-x-1/2">
        <button
          onClick={scrollToTop}
          className="px-16 py-4 rounded-full shadow-[0px_2px_8px_rgba(159,182,255,0.25)] transition-all duration-300 ease-in-out hover:bg-[#E2EFF8]"
        >
          <UpArrowIcon />
        </button>
      </div>
      <footer className="bg-white w-full flex xl:justify-between items-center shadow-md rounded-xl flex-col p-6 gap-8 xl:gap-[50px]">
        <div className="w-full flex hidden">
          <div className="flex xl:justify-between w-full flex-col gap-4 text-center mt-2 xl:flex-row xl:items-center">
            <p>Subscribe to our Newsletter and save 5% on services</p>
            <form className="flex gap-2 md:justify-center">
              <input
                type="email"
                placeholder="Enter your email"
                className="px-4 py-2 blue-border rounded-[15px] w-[600px]"
              />
              <button className="w-fit flex justify-end items-center gap-2.5 py-2 px-6 rounded-full border border-blue-500 text-blue-500 bg-blue-50 hover:bg-blue-500 hover:text-white transition duration-300 undefined">
                <ArrowIcon />
              </button>
            </form>
          </div>
        </div>
        <div className="flex items-center flex-col xl:justify-between w-full gap-6 mt-6 xl:flex-row">
          <div className="flex items-center">
            <Link href="/">
            <img
                src="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/logoEnjoyableDesign.svg?alt=media&token=c5d945d5-e63a-47d4-a763-632b2ff7be7d"
                alt="Logo"
                width={155}
                height={36}
              />
            </Link>
          </div>
          <nav className="flex gap-6 flex-col text-center md:flex-row">
            <Link
              href="/about"
              className="relative pb-1 hover:after:w-full after:absolute after:left-1/2 after:bottom-0 after:w-0 after:h-[1px] after:bg-black after:transition-all after:duration-300 after:transform after:-translate-x-1/2"
            >
              About Us
            </Link>
            <Link
              href="/services"
              className="relative pb-1 hover:after:w-full after:absolute after:left-1/2 after:bottom-0 after:w-0 after:h-[1px] after:bg-black after:transition-all after:duration-300 after:transform after:-translate-x-1/2"
            >
              Services
            </Link>
            <Link
              href="/contact"
              className="relative pb-1 hover:after:w-full after:absolute after:left-1/2 after:bottom-0 after:w-0 after:h-[1px] after:bg-black after:transition-all after:duration-300 after:transform after:-translate-x-1/2"
            >
              Contact Us
            </Link>
            <Link
              href="/services/design"
              className="relative pb-1 hover:after:w-full after:absolute after:left-1/2 after:bottom-0 after:w-0 after:h-[1px] after:bg-black after:transition-all after:duration-300 after:transform after:-translate-x-1/2"
            >
              Design
            </Link>
            <Link
              href="/services/developing"
              className="relative pb-1 hover:after:w-full after:absolute after:left-1/2 after:bottom-0 after:w-0 after:h-[1px] after:bg-black after:transition-all after:duration-300 after:transform after:-translate-x-1/2"
            >
              Developing
            </Link>
            <Link
              href="/services/marketing"
              className="relative pb-1 hover:after:w-full after:absolute after:left-1/2 after:bottom-0 after:w-0 after:h-[1px] after:bg-black after:transition-all after:duration-300 after:transform after:-translate-x-1/2"
            >
              Marketing
            </Link>
          </nav>
          <div className="w-[155px] hidden xl:block"></div>
        </div>
        <div className="flex items-center flex-col gap-4 justify-between w-full text-[#808080] xl:flex-row">
          <div>© 2025 Enjoyable Design Inc.</div>
          <div className="flex gap-6 invisible">
            <Link href="#">
              <button className="flex items-center">
                <FacebookIcon />
              </button>
            </Link>
            <Link href="#">
              <button className="flex items-center">
                <InstagramIcon />
              </button>
            </Link>
          </div>
          <nav className="text-[#808080] flex gap-6">
            <Link className="relative pb-0 hover:after:w-full after:absolute after:left-1/2 after:bottom-0 after:w-0 after:h-[1px] after:bg-[#808080] after:transition-all after:duration-300 after:transform after:-translate-x-1/2" href="/terms">Terms</Link>
            <Link className="relative pb-0 hover:after:w-full after:absolute after:left-1/2 after:bottom-0 after:w-0 after:h-[1px] after:bg-[#808080] after:transition-all after:duration-300 after:transform after:-translate-x-1/2" href="/privacy">Privacy</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
